const DISMISSED_STORAGE_KEY_PREFIX = 'intrack.sdkSetupSidebarCard.dismissed';

export function isSdkSetupSidebarCardDismissed(productId) {
  if (typeof window === 'undefined' || !productId) {
    return false;
  }
  try {
    const value = localStorage.getItem(
      `${DISMISSED_STORAGE_KEY_PREFIX}.${productId}`
    );
    return value === 'true' || value === '1';
  } catch {
    return false;
  }
}

export function persistSdkSetupSidebarCardDismissed(productId) {
  if (typeof window === 'undefined' || !productId) {
    return;
  }
  try {
    localStorage.setItem(
      `${DISMISSED_STORAGE_KEY_PREFIX}.${productId}`,
      'true'
    );
  } catch {
    // ignore quota / private mode errors
  }
}
